module.exports = __webpack_public_path__ + "img/healthy_page05_img4.8a26adf9.png";